import { render } from "./RegionsFilter.vue?vue&type=template&id=0f5fda92&scoped=true"
import script from "./RegionsFilter.vue?vue&type=script&lang=js"
export * from "./RegionsFilter.vue?vue&type=script&lang=js"

import "./RegionsFilter.vue?vue&type=style&index=0&id=0f5fda92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0f5fda92"

export default script